// extracted by mini-css-extract-plugin
module.exports = {"card":"CardImage_card__Tv0du","grid":"CardImage_grid__1MXWc","wrapper":"CardImage_wrapper__QFK-L","photo":"CardImage_photo__GCNDz","list":"CardImage_list__vUgIG"};